import React, { useState } from 'react';
import { useHybridAuth } from '../HybridAuthProvider';
import { useApiClient } from '../api/ApiClientContext';

const DebugPage: React.FC = () => {
  const { user, logout } = useHybridAuth();
  const apiClient = useApiClient();
  const [status, setStatus] = useState<string | null>(null);

  const debugUserStatus = async () => {
    setStatus('Fetching user status...');
    try {
      const response = await apiClient.api.getUserFlowStatusApiV1AuthUserFlowStatusGet();
      console.log('User flow status:', response.data);
      setStatus(JSON.stringify(response.data, null, 2));
    } catch (error) {
      console.error('Error getting user status:', error);
      setStatus('Error getting user status: ' + (error as Error).message);
    }
  };

  const resetUserState = async () => {
    setStatus('Resetting user state...');
    try {
      await apiClient.api.resetUserDataApiV1AuthResetUserDataPost();
      localStorage.clear();
      setStatus('User state reset successfully! Redirecting...');
      setTimeout(() => { window.location.href = '/'; }, 1000);
    } catch (error) {
      console.error('Error resetting user state:', error);
      setStatus('Error resetting user state: ' + (error as Error).message);
    }
  };

  const resetDemoData = async () => {
    setStatus('Resetting demo data...');
    try {
      const response = await apiClient.http.request<{ success: boolean; message: string; date_cleared: string }, any>({
        path: '/api/v1/auth/reset-demo-data',
        method: 'POST',
        secure: true,
        format: 'json',
      });
      setStatus(`Demo data cleared for ${response.data.date_cleared}! Redirecting...`);
      setTimeout(() => { window.location.href = '/'; }, 1000);
    } catch (error) {
      console.error('Error resetting demo data:', error);
      setStatus('Error resetting demo data: ' + (error as Error).message);
    }
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h1 style={{ marginBottom: '20px' }}>Debug Tools</h1>

      <div style={{
        background: '#f5f5f5',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px'
      }}>
        <h2 style={{ marginTop: 0 }}>Current User</h2>
        <p><strong>Name:</strong> {user?.name || 'N/A'}</p>
        <p><strong>Email:</strong> {user?.email || 'N/A'}</p>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        maxWidth: '400px'
      }}>
        <button
          onClick={debugUserStatus}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#0078d4',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#006abc'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0078d4'}
        >
          Debug User Status
        </button>

        <button
          onClick={resetDemoData}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#f57c00',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e65100'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f57c00'}
        >
          Reset Demo Data (Today Only)
        </button>

        <button
          onClick={resetUserState}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#d32f2f',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b71c1c'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#d32f2f'}
        >
          Reset User State
        </button>

        <button
          onClick={handleLogout}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#616161',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#424242'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#616161'}
        >
          Logout
        </button>

        {status && (
          <div style={{
            padding: '12px',
            borderRadius: '6px',
            backgroundColor: status.startsWith('Error') ? '#ffebee' : '#e8f5e9',
            color: status.startsWith('Error') ? '#c62828' : '#2e7d32',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
          }}>
            {status}
          </div>
        )}

        <a
          href="/"
          style={{
            textAlign: 'center',
            marginTop: '20px',
            color: '#0078d4',
            textDecoration: 'none'
          }}
        >
          Back to App
        </a>
      </div>
    </div>
  );
};

export default DebugPage;
